import { Pipe, PipeTransform } from '@angular/core';
import { courseMap } from '../coursesMap';

@Pipe({
  name: 'odImg'
})
export class OdImgPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    console.log(value);
    const defaultOd = courseMap.find(course => course.id == 0).odList[0];
    let found = undefined;
    for (let index = 0; index < courseMap.length; index++) {
      found = courseMap[index].odList.find(od => od.id == value.do_id || od.name.toLowerCase() == value.do_title.toLowerCase())
      if(found) break;   
    }
    
    return found.imgPath || defaultOd.imgPath;

  }

}



// WEBPACK FOOTER //
// ./src/app/pipes/od-img.pipe.ts